define.alias("shared/components/shared/ui/report/share", "settings/components/shared/ui/report/share");